import store from '@/packages/vuex'
import { Middleware } from '@/app/router'
import LogRocket from 'logrocket'

let lastLogRocketIdentity = null
let lastTrackedDepartment = null
let lastTrackedRoles = null

export default new Middleware('Check authentication', ({ next, router, to }) => {
	const isAuthenticated = store.getters['Auth/authenticated']

	if (!isAuthenticated) {
		lastLogRocketIdentity = null
		lastTrackedDepartment = null
		lastTrackedRoles = null
		if (to.name !== 'Auth:Login') {
			router.push({
				name: 'Auth:Login',
				query: { redirect: to.fullPath }
			}).catch(err => {
				if (err.name !== 'NavigationDuplicated') {
					console.error('Navigation Error:', err)
				}
			})
		}
		return
	}

	const user = store.getters['Auth/user']

	try {
		const userRoles = Array.isArray(user?.roles) ? user.roles.map(role => role.name).filter(Boolean).sort() : []
		const identitySignature = JSON.stringify({
			id: user?.id ?? null,
			name: user?.name ?? null,
			email: user?.email ?? null
		})
		const departmentSignature = user?.selectedDepartmentId ?? null
		const rolesSignature = userRoles.join('|')

		if (user?.id && identitySignature !== lastLogRocketIdentity) {
			LogRocket.identify(user.id, {
				name: user.name,
				email: user.email
			})
			lastLogRocketIdentity = identitySignature
		}

		if (departmentSignature && departmentSignature !== lastTrackedDepartment) {
			LogRocket.track('selectedDepartment:' + departmentSignature)
			lastTrackedDepartment = departmentSignature
		}

		if (rolesSignature !== lastTrackedRoles) {
			userRoles.forEach(roleName => {
				LogRocket.track('hasRole:' + roleName)
			})
			lastTrackedRoles = rolesSignature
		}
	} catch (error) {
		console.warn('LogRocket tracking failed:', error)
	}

	return next()
})
